import React, { useState, useCallback } from "react";
import css from "./AluList.module.css";
import AluItemDetail from "../../components/AluItemDetail/AluItemDetail";

const AluList = ({ items, activeComponent, density, setDensity }) => {
  const [selectedItem, setSelectedItem] = useState(items[0]);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [weights, setWeights] = useState({
    totalWeight: "0.000",
    totalWeightPerKg: "0.000",
  });
  const [calcError] = useState("");

  const handleWeightChange = useCallback((newWeights) => {
    const sanitize = (value) => {
      const num = parseFloat(value);
      if (!Number.isFinite(num) || num < 0) return { v: "0.000", invalid: true };
      return { v: num.toFixed(3), invalid: false };
    };

    const updatedWeights = {};
    
    if (newWeights.totalBlacha !== undefined) {
      const sBlacha = sanitize(newWeights.totalBlacha);
      updatedWeights.totalBlacha = sBlacha.v;
    }
    
    if (newWeights.totalWeight !== undefined) {
      const sTotal = sanitize(newWeights.totalWeight);
      updatedWeights.totalWeight = sTotal.v;
    }
    
    if (newWeights.totalWeightPerKg !== undefined) {
      const sPer = sanitize(newWeights.totalWeightPerKg);
      updatedWeights.totalWeightPerKg = sPer.v;
    }

    setWeights(updatedWeights);
  },[]);

  return (
    <>
      <ul className={`${css.buttonGroups} !gap-8 !gap-y-8 !sm:gap-2 !sm:gap-y-4 !md:gap-8 !md:gap-y-8 !lg:gap-6 !lg:gap-y-8`}>
        {items.map((item) => (
          <li
            key={item.id}
            className={`${css.li} ${
              selectedItem === item ? css.selected : ""
            }`}
          >
            <div
              onClick={() => setSelectedItem(item)}
              onMouseOver={() => setHoveredItem(item)}
              onMouseOut={() => setHoveredItem(null)}
              className={css.link}
              title={item.name}
            >
              <img
                src={
                  selectedItem === item || hoveredItem === item
                    ? item.image2
                    : item.image
                }
                alt={item.name}
                width={"40%"}
                height={"100%"}
                title={item.name}
              />
            </div>
          </li>
        ))}
      </ul>

      <div className="details">
        {selectedItem && (
          <AluItemDetail
            item={selectedItem}
            activeComponent={activeComponent}
            density={density}
            setDensity={setDensity}
            onWeightChange={handleWeightChange}
          />
        )}
      </div>
      <div className="info">
        <p>
          * Każdy wynik to masa przypuszczalna - wynik nie uwzględnia tolerancji
          wykonania.
        </p>
        {calcError ? (
          <p className="text-error-text">{calcError}</p>
        ) : (
          ""
        )}
      </div>
      <div className="flex flex-col items-center justify-center w-full">
        {weights.totalBlacha ? (
          <div className="pweight">
            <p>Masa arkusza:</p>
            <span className="redWeight">
              {isNaN(weights.totalBlacha)
                ? "0.000"
                : weights.totalBlacha < 0
                ? "0.000"
                : weights.totalBlacha > 10000000
                ? "Poza limitem"
                : weights.totalBlacha}
            </span>
            <span className="weight">kg/arkusz</span>
          </div>
        ) : (
          ""
        )}
        {weights.totalWeight ? (
          <div className="pweight">
            <p>Waga całkowita:</p>
            <span className="redWeight">
              {isNaN(weights.totalWeight)
                ? "0.000"
                : weights.totalWeight < 0
                ? "0.000"
                : weights.totalWeight > 10000000
                ? "Poza limitem"
                : weights.totalWeight}
            </span>
            <span className="weight">kg</span>
          </div>
        ) : (
          ""
        )}
        {weights.totalWeightPerKg ? (
          <div className="pweight">
            <p>Waga na metr:</p>
            <span className="redWeight">
              {isNaN(weights.totalWeightPerKg)
                ? "0.000"
                : weights.totalWeightPerKg < 0
                ? "0.000"
                : weights.totalWeightPerKg > 10000000
                ? "Poza limitem"
                : weights.totalWeightPerKg}
            </span>
            <span className="weight">kg/m</span>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AluList;